module.exports = __webpack_public_path__ + "static/media/icon-hr-dashboard.be129f3c.svg";